import {Catalog, FileData, FormattedDate} from '../../../../common/types/common';

export enum BankAccountFileType {
    DEALER_ACCOUNT_STATUS_TYPE = 'DEALER_ACCOUNT_STATUS_TYPE',
    DEALER_OFFICIAL_IDENTIFICATION_TYPE = 'DEALER_OFFICIAL_IDENTIFICATION_TYPE',
}

export enum CommissionBankAccountFileType {
    COMMISSION_ACCOUNT_STATUS_TYPE = 'COMMISSION_ACCOUNT_STATUS_TYPE',
    COMMISSION_OFFICIAL_IDENTIFICATION_TYPE = 'COMMISSION_OFFICIAL_IDENTIFICATION_TYPE',
}

export interface BankAccountFile extends FileData {
    key?: string
    fileType?: BankAccountFileType
}

export interface CommissionBankAccountFile extends FileData {
    key?: string
    fileType?: CommissionBankAccountFileType
}

export interface BankAccountState {
    id?: string
    bankAccountId?: string
    accountNumber: string
    bankSelected: Catalog
    beneficiaryName: string
    clabe: string
    dealerAccountStatusFile: BankAccountFile
    dealerOfficialIdentificationFile: BankAccountFile
    owner: Catalog
    createAt: FormattedDate
}

export interface CommissionActFile extends FileData {
    key?: string
    fileType?: CommissionCardFileType
}

export interface CommissionIdentificationFile extends FileData {
    key?: string
    fileType?: CommissionCardFileType
}

export interface CommissionIdentificationGroupFile extends FileData {
    key?: string
    fileType?: CommissionCardFileType
}

export interface CommissionCardBackupCodeFile extends FileData {
    key?: string
    fileType?: CommissionCardFileType
}

export enum CommissionCardFileType {
    COMMISSION_ACT_TYPE = 'COMMISSION_ACT_TYPE',
    COMMISSION_IDENTIFICATION_TYPE = 'COMMISSION_IDENTIFICATION_TYPE',
    COMMISSION_IDENTIFICATION_GROUP_TYPE = 'COMMISSION_IDENTIFICATION_GROUP_TYPE',
    COMMISSION_CARD_BACKUP_CODE_TYPE = 'COMMISSION_CARD_BACKUP_CODE_TYPE',
}

export interface CardCommissionAccountState {
    id?: string
    commissionCardId?: string
    cardNumber: string
    cardHolderName: string
    owner: Catalog
    createAt: FormattedDate
    actFile: CommissionActFile
    identificationFile: CommissionIdentificationFile
    identificationGroupFile: CommissionIdentificationGroupFile
    cardBackupCodeFile: CommissionCardBackupCodeFile
}

export interface CommissionBankAccountState {
    id?: string
    bankAccountId?: string
    accountNumber: string
    bank: Catalog
    beneficiaryName: string
    clabe: string
    dealerAccountStatusFile: CommissionBankAccountFile
    dealerOfficialIdentificationFile: CommissionBankAccountFile
    createdAt: FormattedDate
    registerDate: string;
}

export class BankAccountViewFieldErrorState {
    accountNumberFieldError: string;
    bankSelectedFieldError: string;
    beneficiaryNameFieldError: string;
    clabeFieldError: string;
    dealerAccountStatusFileFieldError: string;
    dealerOfficialIdentificationFileFieldError: string;

    constructor(accountNumberFieldError: string, bankSelectedFieldError: string, beneficiaryNameFieldError: string,
                clabeFieldError: string, dealerAccountStatusFileFieldError: string,
                dealerOfficialIdentificationFileFieldError: string) {
        this.accountNumberFieldError = accountNumberFieldError;
        this.bankSelectedFieldError = bankSelectedFieldError;
        this.beneficiaryNameFieldError = beneficiaryNameFieldError;
        this.clabeFieldError = clabeFieldError;
        this.dealerAccountStatusFileFieldError = dealerAccountStatusFileFieldError;
        this.dealerOfficialIdentificationFileFieldError = dealerOfficialIdentificationFileFieldError;
    }
}

export class CardCommissionAccountViewFieldErrorState {
    cardNumberFieldError: string;
    beneficiaryNameFieldError: string;
    actFileFieldError: string;
    identificationFileFieldError: string;
    identificationGroupFileFieldError: string;
    cardBackupCodeFileFieldError: string;

    constructor(cardNumberFieldError: string,
                beneficiaryNameFieldError: string,
                actFileFieldError: string,
                identificationFileFieldError: string,
                identificationGroupFileFieldError: string,
                cardBackupCodeFileFieldError: string,
                ) {
        this.cardNumberFieldError = cardNumberFieldError;
        this.beneficiaryNameFieldError = beneficiaryNameFieldError;
        this.actFileFieldError = actFileFieldError;
        this.identificationFileFieldError = identificationFileFieldError;
        this.identificationGroupFileFieldError = identificationGroupFileFieldError;
        this.cardBackupCodeFileFieldError = cardBackupCodeFileFieldError;
    }
}

export interface BankAccountViewState {
    fieldErrors: BankAccountViewFieldErrorState
}

export interface CardCommissionAccountViewState {
    fieldErrors: CardCommissionAccountViewFieldErrorState
}

export interface BankAccountSummaryState  {
    bankAccountId: string;
    accountNumber: string;
    bank: string;
    beneficiaryName: string;
    clabe: string;
    dealerAccountStatusFile: BankAccountFile;
    dealerOfficialIdentificationFile: BankAccountFile;
    ownerName: string;
    ownerId: string;
    createdAt: FormattedDate;
}

export interface CardCommissionAccountSummaryState  {
    commissionCardId: string;
    cardNumber: string;
    cardHolderName: string;
    ownerName: string;
    ownerId: string;
    createdAt: FormattedDate;
    actFile?: CommissionActFile
    identificationFile?: CommissionIdentificationFile
    identificationGroupFile?: CommissionIdentificationGroupFile
    cardBackupCodeFile?: CommissionCardBackupCodeFile
}

export interface CommissionBankAccountSummaryState  {
    accountNumber: string;
    bank: Catalog;
    beneficiaryName: string;
    clabe: string;
    dealerAccountStatusFile: CommissionBankAccountFile;
    dealerOfficialIdentificationFile: CommissionBankAccountFile;
    createdAt: FormattedDate;
    registerDate: string;
    loadExistCommissionBankAccount: boolean;
}

export class FinancialEntity {
    type: string;
    name: string;
    status: boolean;

    constructor(type: string, name: string, status: boolean) {
        this.type = type;
        this.name = name;
        this.status = status;
    }
}
